export default __webpack_public_path__ + "static/media/no_results_found.e681250e.png";